// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jb-1";
export var stateContainer = "_jb-0";